import { useMemo } from 'react';

import { useProfile } from '@mint-lib/profile-helpers';
import { enGB, enUS, it, ptBR, type Locale } from 'date-fns/locale';

const localeMap = new Map([
  ['en-GB', enGB],
  ['en-US', enUS],
  ['it-IT', it],
  ['pt-BR', ptBR],
]);

/**
 * @deprecated Use `useDateLocalize` from the `@mint-lib/tw-components/hooks`
 */
export const useDateLocalize = () => {
  const { getProfileField } = useProfile();

  const locale = getProfileField('locale');

  const formattingConfig =
    getProfileField('formattingConfig')?.datesFormat || locale;

  const localize = useMemo(
    () =>
      ({
        ...localeMap.get(locale),
        options: localeMap.get(formattingConfig)?.options,
        formatLong: localeMap.get(formattingConfig)?.formatLong,
      }) as Locale,
    [formattingConfig, locale],
  );

  return localize;
};
